import type { SettingsOptions } from '@kelan-ui/vue/settings'
import { diffTwoObj, mergeWithoutUndefinedProps } from '@kelan-ui/vue/settings'
import settingsDefault from '@/settings'

export const useAppPreferencesStore = defineStore(
  'appPreferences',
  () => {
    const appSettingsStore = useAppSettingsStore()
    const appAccountStore = useAppAccountStore()

    const isEnabled = computed(() => {
      return Object.values(appSettingsStore.settings.app.preferences).some((value) => {
        if (typeof value === 'boolean') {
          return value
        }
        else if (typeof value === 'object' && value !== null) {
          return Object.values(value).includes(true)
        }
        return false
      })
    })

    const immediateUpdate = ref(true)
    watch(() => appSettingsStore.settings, () => {
      immediateUpdate.value && updatePreferences(appSettingsStore.settings)
    }, {
      deep: true,
    })

    // 获取偏好设置
    async function getPreferences() {
      let data = {}
      if (localStorage.has('preferences')) {
        data = JSON.parse(localStorage.getItem('preferences') as string)[appAccountStore.account] || {}
      }
      appSettingsStore.updateSettings(mergeWithoutUndefinedProps(data, appSettingsStore.settings), true)
    }
    // 更新偏好设置
    async function updatePreferences(data: SettingsOptions = {}) {
      if (!appAccountStore.isLogin) {
        return
      }
      data = diffTwoObj(settingsDefault, data)
      delete data.app
      const preferencesData = localStorage.has('preferences') ? JSON.parse(localStorage.getItem('preferences') as string) : {}
      preferencesData[appAccountStore.account] = data
      localStorage.setItem('preferences', JSON.stringify(preferencesData))
    }

    return {
      isEnabled,
      immediateUpdate,
      getPreferences,
      updatePreferences,
    }
  },
)
